import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-3 p-5"><Shimmer height="24px" width="120px" /><Shimmer height="130px" width="100%" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Loading;